import { CheckCircle2, Download, EllipsisVertical, Share, SquarePlus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { promptInstall, useInstallMode } from '@/lib/pwa';

/** Hộp "Cài ứng dụng lên điện thoại": Android bấm một nút; iPhone làm theo 3 bước của Safari. */
export function InstallAppDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const mode = useInstallMode();

  const install = async () => {
    const ok = await promptInstall();
    if (ok) {
      toast.success('Đã cài ứng dụng Minh Tiến. Mở từ biểu tượng trên màn hình chính.');
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()} title="Cài ứng dụng Minh Tiến" description="Mở nhanh từ màn hình chính, toàn màn hình, nhận thông báo.">
      {mode === 'installed' && (
        <p className="flex items-center gap-2 text-sm">
          <CheckCircle2 className="size-5 text-success" /> Anh/chị đang dùng bản đã cài.
        </p>
      )}
      {mode === 'prompt' && (
        <div className="space-y-3 text-sm">
          <p>Bấm nút bên dưới, rồi chọn <b>Cài đặt</b> trong hộp trình duyệt hiện ra.</p>
          <Button size="lg" className="w-full" onClick={() => void install()}>
            <Download /> Cài ứng dụng
          </Button>
        </div>
      )}
      {mode === 'ios' && (
        <ol className="list-decimal space-y-2 pl-5 text-sm" data-testid="ios-install-steps">
          <li>
            Mở trang này bằng <b>Safari</b> (Chrome trên iPhone không cài được).
          </li>
          <li>
            Bấm nút <Share className="inline size-4 align-text-bottom" /> <b>Chia sẻ</b> ở thanh dưới.
          </li>
          <li>
            Kéo xuống, chọn <SquarePlus className="inline size-4 align-text-bottom" /> <b>Thêm vào MH chính</b>, rồi bấm <b>Thêm</b>.
          </li>
          <li>Mở ứng dụng từ biểu tượng Minh Tiến vừa có. Chỉ bản mở từ biểu tượng mới nhận được thông báo.</li>
        </ol>
      )}
      {mode === 'manual' && (
        <ol className="list-decimal space-y-2 pl-5 text-sm">
          <li>
            Mở trang bằng <b>Chrome</b> (Android, máy tính) hoặc <b>Edge</b>.
          </li>
          <li>
            Bấm <EllipsisVertical className="inline size-4 align-text-bottom" /> menu trình duyệt, chọn <b>Cài đặt ứng dụng</b> hoặc <b>Thêm vào màn hình chính</b>.
          </li>
          <li>Nếu không thấy mục này, tải lại trang một lần rồi thử lại.</li>
        </ol>
      )}
    </Dialog>
  );
}
